/* global VueRouter:true */
import Dashboard from '../layout/home'
import HomeView from '../layout/home/home'
import HomeContentView from '../layout/home/mainContent'
import NotFoundComponent from '../layout/404'
import ConsultComponent from '../layout/consult/index'
import ConsultDetailComponent from '../layout/consult/detail'
import IntroductionComponent from '../layout/introduction/index'
const brightDetail = () => import('../layout/brightDetail/index')
const bright = () => import('../layout/bright/index')
const shisanwu = () => import('../layout/shisanwu/index')
const industyNews = () => import('../layout/industyNews/index')
const newsTrends = () => import('../layout/newsTrends/index')
const dataAssemble = () => import('../layout/dataAssemble/index')
const oneStep = () => import('../layout/oneStep/index')
const achievements = () => import('../layout/achievements/index')
const VRShow = () => import('../layout/VRShow/index')
const majorProject = () => import('../layout/majorProject/index')
const keySpecial = () => import('../layout/keySpecial/index')
const canonical = () => import('../layout/canonical/index')
const project = () => import('../layout/project/index')
const projectDetail = () => import('../layout/project/detail')
const fruitDetail = () => import('../layout/project/fruitDetail')
const article = () => import('../layout/article/index')
const commonList = () => import('../layout/common/commonList')
const metroloyList = () => import('../layout/metroloylist/metroloyList')
const standard = () => import('../layout/standArd/standard')
const certification = () => import('../layout/certificaTion/certification')
const checkout = () => import('../layout/checKout/checkout')
const metroloyDetail = () => import('../layout/detail/metroloyDetail')
const standardDetail = () => import('../layout/detail/standardDetail')
const testDetail = () => import('../layout/detail/testDetail')
const certificationDetail = () => import('../layout/detail/certificationDetail')
const cnasDetail = () => import('../layout/detail/cnasDetail')
const cmaDetail = () => import('../layout/detail/cmaDetail')
const analysisData = () => import('../layout/analysis/analysisData')
const newsDetail = () => import('../layout/detail/newsDetail')
const websiteSearch = () => import('../layout/websiteSearch')
const notice = () => import('../layout/notice')

const vueRouter = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      redirect: '/dashboard',
      component: Dashboard,
      children: [
        {
          path: '/notice',
          component: notice,
          name: 'notice'
        },
        {
          path: '/brightDetail',
          component: brightDetail,
          name: 'brightDetail'
        },
        {
          path: '/bright',
          component: bright,
          name: 'bright'
        },
        {
          name: 'dashboard',
          path: '/dashboard',
          component: HomeView,
          meta: { title: '首页' }
        },
        {
          path: '/dataAssemble',
          component: dataAssemble,
          name: 'dataAssemble',
          meta: { title: '数说NQI' }
        },
        {
          path: '/oneStep',
          component: oneStep,
          name: 'oneStep',
          meta: { title: '一站式服务' }
        },
        {
          path: '/newsTrends',
          component: newsTrends,
          name: 'newsTrends',
          meta: { title: '新闻动态' }
        },
        {
          path: '/shisanwu',
          component: shisanwu,
          name: 'shisanwu',
          meta: { title: '十三五' }
        },
        {
          path: '/achievements',
          component: achievements,
          name: 'achievements',
          meta: { title: '成果展示' }
        },
        {
          path: '/industyNews',
          component: industyNews,
          name: 'industyNews',
          meta: { title: '成果概览' }
        },
        {
          path: '/article',
          component: article,
          name: 'article'
        },
        {
          path: '/VRShow',
          component: VRShow,
          name: 'VRShow',
          meta: { title: 'VR' }
        },
        {
          path: '/majorProject',
          component: majorProject,
          name: 'majorProject',
          meta: { title: '重大专项' }
        },
        {
          path: '/keySpecial',
          component: keySpecial,
          name: 'keySpecial',
          meta: { title: '重点专项' }
        },
        {
          path: '/canonical',
          component: canonical,
          name: 'canonical'
        },
        {
          path: '/project',
          component: project,
          name: 'project'
        },
        {
          path: '/projectDetail',
          component: projectDetail,
          name: 'projectDetail'
        },
        {
          path: '/fruitDetail',
          component: fruitDetail,
          name: 'fruitDetail'
        },
        {
          path: '/commonList',
          component: commonList,
          name: 'commonList'
        },
        {
          path: '/metroloyList',
          component: metroloyList
        },
        {
          path: '/newsDetail',
          component: newsDetail
        },
        {
          path: '/metroloyDetail',
          component: metroloyDetail
        },
        {
          path: '/standardDetail',
          component: standardDetail
        },
        {
          path: '/testDetail',
          component: testDetail
        },
        {
          path: '/certificationDetail',
          component: certificationDetail
        },
        {
          path: '/cnasDetail',
          component: cnasDetail
        },
        {
          path: '/cmaDetail',
          component: cmaDetail
        },
        {
          path: '/analysisData',
          component: analysisData
        },
        {
          path: '/standard',
          component: standard
        },
        {
          path: '/certification',
          component: certification
        },
        {
          path: '/checkout',
          component: checkout
        },
        {
          path: '/consult',
          component: ConsultComponent
        },
        {
          path: '/consult/detail',
          component: ConsultDetailComponent
        },
        {
          path: '/introduction',
          component: IntroductionComponent
        },
        {
          path: '/websiteSearch',
          component: websiteSearch
        },
        {path: '/404', component: NotFoundComponent}
      ]
    },
    {
      path: '/custom/*',
      component: Dashboard,
      children: [
        {path: '/custom/*', component: HomeContentView}
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// 验证用户是否登录
vueRouter.beforeEach((to, from, next) => {
  // 如果是页面刷新，state值被清空，从session中获取
  // if (!store.state.user) {
  //   if (!store.state.user) {
  //     next('/dashboard')
  //   }
  // }
  next()
})

export default vueRouter



// WEBPACK FOOTER //
// ./src/router/index.js